export const SHEET_ROW_HEIGHT = 24;
export const SHEET_ROW_GAP_HEIGHT = 12;
export const SHEET_TOTAL_HEIGHT = SHEET_ROW_HEIGHT + SHEET_ROW_GAP_HEIGHT;

export const getPlaceholderHeight = (item, forCurrentFile = false) => {
  let height = 0;

  let mockedSheetsCount = 0;

  if (!forCurrentFile)
    mockedSheetsCount =
      (item.currentFile?.sheets?.length || 0) - (item.previousFile?.sheets?.length || 0);
  else
    mockedSheetsCount =
      (item.previousFile?.sheets?.length || 0) - (item.currentFile?.sheets?.length || 0);

  height += SHEET_TOTAL_HEIGHT * mockedSheetsCount;
  height += 2 * SHEET_TOTAL_HEIGHT - 10; // File height

  //   if (hasPlus) height += SHEET_TOTAL_HEIGHT;

  return height;
};
